import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('fr');
    this.translate.use('fr');

    // Need this to force translate service to load all languages we support
    // Todo re enable english when we support it.
    const supportedLangs = [/*"en",*/ 'fr'];
    supportedLangs.forEach((language) => {
      this.translate.reloadLang(language);
    });
  }
}
